import { FC } from 'react';

import { IconButton, Tooltip } from '@mui/material';

import { ChatWidgetIcon, TrblCloseIcon } from '@/components/Icons';
import { useGetMySDKUser, useIntercomMessenger } from '@/hooks';

const INTERCOM_LAUNCHER_ID = 'treble-intercom-launcher';

export const SupportButton: FC = () => {
  const { data: sdkUser } = useGetMySDKUser();
  const { toggleWidget, isOpen, isReady, unreadCount } = useIntercomMessenger(sdkUser?.id, !!sdkUser);

  const hasUnread = unreadCount > 0 && !isOpen;

  let iconFill = '#dadada';
  if (hasUnread) {
    iconFill = '#00bfff';
  } else if (isOpen) {
    iconFill = '#f5f5f5';
  }

  const tooltipTitle = !isReady
    ? 'Chat unavailable — try disabling your ad blocker and refreshing'
    : isOpen
      ? 'Close chat'
      : 'Support chat';

  return (
    <Tooltip title={tooltipTitle} arrow>
      <span>
        <IconButton
          id={INTERCOM_LAUNCHER_ID}
          disabled={!isReady}
          disableRipple
          aria-label={isOpen ? 'Close chat' : 'Open support chat'}
          onClick={() => {
            if (isReady) toggleWidget();
          }}
          sx={{
            width: 24,
            height: 24,
            padding: 0,
            borderRadius: '25px',
            overflow: 'hidden',
            opacity: isReady ? 1 : 0.5,
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
            },
          }}>
          {isOpen ? (
            <TrblCloseIcon />
          ) : (
            <ChatWidgetIcon fill={iconFill} height="16" width="16" />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};
